import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Item da Venda", -1)
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-17 ant-col-xl-17" }, null, -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Criar Ordem de Produção", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ss-movimento-comercial-cabecalho-fixo" }
const _hoisted_12 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Total do Produto", -1)
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Desconto", -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Frete", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Seguro", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Outras Despesas", -1)
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Total da Venda", -1)
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-3",
  style: {"background-color":"#40a9ff"}
}
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-movimento-comercial-campo-totalizador" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"white","font-weight":"bolder"} }, "Total do Item", -1)
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  class: "ant-row",
  style: {"height":"100%"}
}
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_45 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_46 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_47 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_48 = { class: "ant-row" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_50 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_51 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_52 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_53 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_54 = { class: "ant-row" }
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "ant-row" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_59 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_60 = {
  class: "ant-row",
  style: {"min-height":"3cm","gap":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_produto_movimento = _resolveComponent("selecionar-produto-movimento")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_item_tabela_preco_produto = _resolveComponent("selecionar-item-tabela-preco-produto")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_cenario_fiscal = _resolveComponent("selecionar-cenario-fiscal")!
  const _component_selecionar_cfop = _resolveComponent("selecionar-cfop")!
  const _component_venda_item_ordem_producao_card = _resolveComponent("venda-item-ordem-producao-card")!
  const _component_nota_fiscal_item_detalhe = _resolveComponent("nota-fiscal-item-detalhe")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_nota_fiscal_item_impostos = _resolveComponent("nota-fiscal-item-impostos")!
  const _component_nota_fiscal_item_estoques = _resolveComponent("nota-fiscal-item-estoques")!
  const _component_nota_fiscal_item_dados_especificos = _resolveComponent("nota-fiscal-item-dados-especificos")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    maskClosable: false,
    "wrap-class-name": _ctx.state.telaMobile ? 'full-modal ss-modal-vendas' : 'scroll-modal ss-modal-vendas'
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_tooltip, {
            placement: "top",
            title: "Item Anterior"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                disabled: !_ctx.props.existeAnterior || _ctx.state.item.codigo === undefined,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.itemAnterior && _ctx.itemAnterior(...args)))
              }, [
                _createVNode(_component_icone, { nome: "navegacao-anterior" })
              ], 8, _hoisted_5)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tooltip, {
            placement: "top",
            title: "Próximo Item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                disabled: !_ctx.props.existeProximo || _ctx.state.item.codigo === undefined,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.proximoItem && _ctx.proximoItem(...args)))
              }, [
                _createVNode(_component_icone, { nome: "navegacao-proximo" })
              ], 8, _hoisted_6)
            ]),
            _: 1
          }),
          (_ctx.state.codigoEngenharia > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.criarOrdemProducao && _ctx.criarOrdemProducao(...args)))
              }, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.props.editavel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
              }, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 10 }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.precoUnitario * _ctx.state.item.itemNotaFiscal.quantidade, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_17)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.valorDesconto, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.valorFrete, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.valorSeguro, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_26)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.outrasDespesas, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_29)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.impostos.valorTotalTributos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_32)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.totalNota, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_35)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("input", {
                          type: "text",
                          class: "ant-input hidden ss-movimento-input-totalizador",
                          style: {"background-color":"#40a9ff","color":"white","font-weight":"bolder"},
                          value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.valorTotal, 2, true),
                          disabled: "true"
                        }, null, 8, _hoisted_40)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  _createVNode(_component_card, { class: "ss-card" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_a_form_item, {
                            label: "Produto",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_produto_movimento, {
                                classCss: "ss-venda-modal-itens",
                                empresas: [_ctx.props.empresa],
                                codigoSelecionado: _ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao,
                                "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao) = $event)),
                                descricao: _ctx.state.item.itemNotaFiscal.descricao,
                                "onUpdate:descricao": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.descricao) = $event)),
                                codigoUnidadePrincipal: _ctx.state.item.itemNotaFiscal.codigoUnidadePrincipal,
                                "onUpdate:codigoUnidadePrincipal": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.codigoUnidadePrincipal) = $event)),
                                fatorUnidadePrincipal: _ctx.state.item.itemNotaFiscal.fatorUnidadePrincipal,
                                "onUpdate:fatorUnidadePrincipal": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.fatorUnidadePrincipal) = $event)),
                                codigoInterno: _ctx.state.item.itemNotaFiscal.codigoProduto,
                                "onUpdate:codigoInterno": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.codigoProduto) = $event)),
                                codigoBarras: _ctx.state.item.itemNotaFiscal.codigoBarras,
                                "onUpdate:codigoBarras": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.codigoBarras) = $event)),
                                origemMercadoria: _ctx.state.item.itemNotaFiscal.impostos.origemMercadoria,
                                "onUpdate:origemMercadoria": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.impostos.origemMercadoria) = $event)),
                                codigoNcm: _ctx.state.item.itemNotaFiscal.impostos.codigoNcm,
                                "onUpdate:codigoNcm": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.impostos.codigoNcm) = $event)),
                                ncm: _ctx.state.item.itemNotaFiscal.impostos.ncm,
                                "onUpdate:ncm": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.impostos.ncm) = $event)),
                                filtrarVinculoEstoqueSaida: true,
                                buscarDadosAtualizados: _ctx.props.atualizarValores,
                                disabled: !_ctx.props.editavel,
                                limparSelecao: false,
                                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.obterDadosFiscaisProduto())),
                                onValorDigitado: _cache[14] || (_cache[14] = ($event: any) => (_ctx.atualizarAlteracaoItem())),
                                onKeyup: [
                                  _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["tab"])),
                                  _cache[16] || (_cache[16] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                                ],
                                onKeydown: _cache[17] || (_cache[17] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                              }, null, 8, ["empresas", "codigoSelecionado", "descricao", "codigoUnidadePrincipal", "fatorUnidadePrincipal", "codigoInterno", "codigoBarras", "origemMercadoria", "codigoNcm", "ncm", "buscarDadosAtualizados", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_a_form_item, {
                            label: "Item de Terceiro",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                radioButton: true,
                                valor: _ctx.state.item.itemTerceiro,
                                "onUpdate:valor": [
                                  _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.item.itemTerceiro) = $event)),
                                  _ctx.itensTerceiros
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["valor", "disabled", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_a_form_item, {
                            label: "Movimentar Estoque",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                radioButton: true,
                                valor: _ctx.state.item.itemNotaFiscal.movimentarEstoque,
                                "onUpdate:valor": [
                                  _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.movimentarEstoque) = $event)),
                                  _ctx.limparEstoques
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["valor", "disabled", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_a_form_item, {
                            label: "Compor Total",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                radioButton: true,
                                valor: _ctx.state.item.itemNotaFiscal.compoeTotal,
                                "onUpdate:valor": [
                                  _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.compoeTotal) = $event)),
                                  _ctx.calcularTotalNota
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["valor", "disabled", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_component_a_form_item, {
                            label: "Unidade",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_selecionar_unidade_produto_movimento, {
                                classCss: "ss-venda-modal-itens",
                                apenasUnidadePrincipal: false,
                                codigoProdutoDefinicao: _ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao,
                                editavel: _ctx.props.editavel,
                                codigoUnidadeSelecionada: _ctx.state.item.itemNotaFiscal.codigoUnidade,
                                "onUpdate:codigoUnidadeSelecionada": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.codigoUnidade) = $event)),
                                descricao: _ctx.state.item.itemNotaFiscal.descricaoUnidade,
                                "onUpdate:descricao": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.descricaoUnidade) = $event)),
                                sigla: _ctx.state.item.itemNotaFiscal.siglaUnidade,
                                "onUpdate:sigla": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.siglaUnidade) = $event)),
                                fracionar: _ctx.state.item.itemNotaFiscal.fracionarUnidade,
                                "onUpdate:fracionar": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.fracionarUnidade) = $event)),
                                casasDecimais: _ctx.state.item.itemNotaFiscal.casasDecimaisUnidade,
                                "onUpdate:casasDecimais": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.casasDecimaisUnidade) = $event)),
                                fatorConversao: _ctx.state.item.itemNotaFiscal.fatorConversao,
                                "onUpdate:fatorConversao": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.fatorConversao) = $event)),
                                percentualFormacaoPreco: _ctx.state.item.percentualFormacaoPreco,
                                "onUpdate:percentualFormacaoPreco": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.item.percentualFormacaoPreco) = $event)),
                                apresentarApenasSigla: true,
                                disabled: (!_ctx.props.editavel || (_ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao === 0)),
                                key: ('UNIDADE' + _ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao),
                                buscarDadosAtualizados: _ctx.props.atualizarValores,
                                onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.atualizarAlteracaoItem()))
                              }, null, 8, ["codigoProdutoDefinicao", "editavel", "codigoUnidadeSelecionada", "descricao", "sigla", "fracionar", "casasDecimais", "fatorConversao", "percentualFormacaoPreco", "disabled", "buscarDadosAtualizados"]))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_a_form_item, {
                            label: "Quantidade",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: _ctx.state.item.itemNotaFiscal.casasDecimaisUnidade,
                                fracionar: _ctx.state.item.itemNotaFiscal.fracionarUnidade,
                                valor: _ctx.state.item.itemNotaFiscal.quantidade,
                                "onUpdate:valor": [
                                  _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.quantidade) = $event)),
                                  _ctx.atualizarQtdEstoque
                                ],
                                disabled: !_ctx.editavel,
                                onValorDigitado: _cache[30] || (_cache[30] = ($event: any) => (_ctx.atualizarAlteracaoItem()))
                              }, null, 8, ["quantidadeCasasDecimais", "fracionar", "valor", "disabled", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor Unitário",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_a_popover, {
                                key: ('PRECO' + _ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao),
                                title: "Tabelas de Preços",
                                trigger: "focus",
                                open: (_ctx.props.editavel && _ctx.state.apresentarTabelasPrecos)
                              }, {
                                content: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_selecionar_item_tabela_preco_produto, {
                                    layoutCheckBox: true,
                                    empresas: [_ctx.props.empresa],
                                    "codigos-especificos": _ctx.props.tabelasPrecos,
                                    codigoProdutoDefinicao: _ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao,
                                    codigoItemSelecionado: _ctx.state.item.codigoTabelaPrecoItemProduto,
                                    "onUpdate:codigoItemSelecionado": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.item.codigoTabelaPrecoItemProduto) = $event)),
                                    casasDecimais: _ctx.state.item.itemNotaFiscal.casasDecimaisPrecoUnitario,
                                    "onUpdate:casasDecimais": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.casasDecimaisPrecoUnitario) = $event)),
                                    dadosItemTabelaPrecoSelecionado: _ctx.state.item.dadosPrecoProduto,
                                    "onUpdate:dadosItemTabelaPrecoSelecionado": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.item.dadosPrecoProduto) = $event)),
                                    processando: _ctx.state.carregando,
                                    "onUpdate:processando": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.carregando) = $event)),
                                    emDigitacao: _ctx.state.item.emDigitacao,
                                    "onUpdate:emDigitacao": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.item.emDigitacao) = $event)),
                                    disabled: !_ctx.props.editavel,
                                    apresentarPrecos: _ctx.state.apresentarTabelasPrecos,
                                    onDefinirPrecoSelecionado: _cache[36] || (_cache[36] = ($event: any) => (_ctx.defineValorUnitarioCalculaTotal($event))),
                                    onValorDigitado: _cache[37] || (_cache[37] = ($event: any) => (_ctx.atualizarAlteracaoItem()))
                                  }, null, 8, ["empresas", "codigos-especificos", "codigoProdutoDefinicao", "codigoItemSelecionado", "casasDecimais", "dadosItemTabelaPrecoSelecionado", "processando", "emDigitacao", "disabled", "apresentarPrecos"]), [
                                    [_vShow, (_ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao > 0)]
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_component_campo_numerico, {
                                    monetario: true,
                                    classCss: "ss-venda-modal-itens",
                                    valor: _ctx.state.item.itemNotaFiscal.precoUnitario,
                                    "onUpdate:valor": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.precoUnitario) = $event)),
                                    emDigitacao: _ctx.state.item.emDigitacao,
                                    "onUpdate:emDigitacao": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.item.emDigitacao) = $event)),
                                    disabled: !_ctx.props.editavel,
                                    quantidadeCasasDecimais: _ctx.state.item.itemNotaFiscal.casasDecimaisPrecoUnitario,
                                    key: ('VUNIT' + _ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao),
                                    onFocus: _cache[40] || (_cache[40] = ($event: any) => {_ctx.state.apresentarTabelasPrecos = true;}),
                                    onBlur: _cache[41] || (_cache[41] = ($event: any) => {_ctx.state.apresentarTabelasPrecos = false;}),
                                    onValorDigitado: _cache[42] || (_cache[42] = ($event: any) => (_ctx.atualizarAlteracaoItem()))
                                  }, null, 8, ["valor", "emDigitacao", "disabled", "quantidadeCasasDecimais"]))
                                ]),
                                _: 1
                              }, 8, ["open"]))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_a_form_item, {
                            label: "Desconto",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.itemNotaFiscal.valorDesconto,
                                "onUpdate:valor": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.valorDesconto) = $event)),
                                disabled: !_ctx.editavel,
                                onValorDigitado: _cache[44] || (_cache[44] = ($event: any) => (_ctx.atualizarAlteracaoItem()))
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor Total",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.itemNotaFiscal.valorTotal,
                                "onUpdate:valor": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.valorTotal) = $event)),
                                disabled: true,
                                onValorDigitado: _cache[46] || (_cache[46] = ($event: any) => (_ctx.atualizarAlteracaoItem()))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_a_form_item, {
                            label: "Informações Adicionais",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.informacaoAdicional) = $event)),
                                disabled: !_ctx.props.editavel
                              }, null, 8, _hoisted_56), [
                                [_vModelText, _ctx.state.item.itemNotaFiscal.informacaoAdicional]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, {
                    class: "ss-card",
                    titulo: "INFORMAÇÕES FISCAIS"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_a_form_item, {
                            label: "Cenário Fiscal",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_cenario_fiscal, {
                                codigoSelecionado: _ctx.state.item.itemNotaFiscal.impostos.codigoCenarioFiscal,
                                "onUpdate:codigoSelecionado": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.impostos.codigoCenarioFiscal) = $event)),
                                disabled: !_ctx.editavel
                              }, null, 8, ["codigoSelecionado", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_component_a_form_item, {
                            label: "CFOP",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_cfop, {
                                tipoOperacao: _ctx.state.tipoOperacaoCfop,
                                codigoSelecionado: _ctx.state.item.itemNotaFiscal.impostos.codigoCfop,
                                "onUpdate:codigoSelecionado": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.impostos.codigoCfop) = $event)),
                                cfopSelecionado: _ctx.state.item.itemNotaFiscal.impostos.cfop,
                                "onUpdate:cfopSelecionado": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.impostos.cfop) = $event)),
                                disabled: !_ctx.editavel
                              }, null, 8, ["tipoOperacao", "codigoSelecionado", "cfopSelecionado", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.state.item.ordensProducaoVinculadas && _ctx.state.item.ordensProducaoVinculadas.length > 0)
                    ? (_openBlock(), _createBlock(_component_card, {
                        key: 0,
                        class: "ss-card",
                        titulo: "ORDENS DE PRODUÇÃO VINCULADAS"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_60, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.item.ordensProducaoVinculadas, (op) => {
                              return (_openBlock(), _createBlock(_component_venda_item_ordem_producao_card, {
                                key: op.codigo,
                                "ordem-producao": op
                              }, null, 8, ["ordem-producao"]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_tabs, {
                    class: "ss-card",
                    activeKey: _ctx.state.abaAtiva,
                    "onUpdate:activeKey": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.state.abaAtiva) = $event)),
                    forceRender: "true"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, {
                        key: "1",
                        tab: "DETALHES DO ITEM"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_nota_fiscal_item_detalhe, {
                            item: _ctx.state.item.itemNotaFiscal,
                            "onUpdate:item": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.state.item.itemNotaFiscal) = $event)),
                            editavel: _ctx.props.editavel,
                            onCalcular: _cache[52] || (_cache[52] = ($event: any) => (_ctx.calcularTributacoes()))
                          }, null, 8, ["item", "editavel"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "2",
                        tab: "IMPOSTOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_nota_fiscal_item_impostos, {
                            impostos: _ctx.state.item.itemNotaFiscal.impostos,
                            "onUpdate:impostos": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.impostos) = $event)),
                            editavel: _ctx.props.editavel,
                            onCalcularTributacoes: _cache[54] || (_cache[54] = ($event: any) => (_ctx.calcularTributacoes()))
                          }, null, 8, ["impostos", "editavel"])
                        ]),
                        _: 1
                      }),
                      (_ctx.state.item.itemNotaFiscal.movimentarEstoque)
                        ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: "3",
                            tab: "ESTOQUE"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_item_estoques, {
                                empresa: _ctx.props.empresa,
                                pessoa: _ctx.props.pessoa,
                                item: _ctx.state.item.itemNotaFiscal,
                                "onUpdate:item": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.state.item.itemNotaFiscal) = $event)),
                                editavel: _ctx.props.editavel,
                                classeCss: "ss-modal-compras"
                              }, null, 8, ["empresa", "pessoa", "item", "editavel"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_tab_pane, {
                        key: "4",
                        tab: "DADOS ESPECÍFICOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_nota_fiscal_item_dados_especificos, {
                            empresa: _ctx.props.empresa,
                            item: _ctx.state.item.itemNotaFiscal,
                            "onUpdate:item": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.state.item.itemNotaFiscal) = $event)),
                            editavel: _ctx.props.editavel
                          }, null, 8, ["empresa", "item", "editavel"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["activeKey"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}